// Создаем Proxy для автоматической работы с localStorage
const storage = new Proxy({}, {
    get(target, prop) {
        // Игнорируем системные свойства
        if (prop === 'constructor' || prop === '__proto__' || prop === 'toString') {
            return undefined;
        }
        
        // Специальные методы - возвращаем функции
        if (prop === 'getItem' || prop === 'setItem' || prop === 'removeItem' || prop === 'clear') {
            return function(...args) {
                return localStorage[prop](...args);
            };
        }
        
        // Чтение из localStorage
        const value = localStorage.getItem(prop);
        
        // Если ключа нет - возвращаем undefined
        if (value === null) return undefined;
        
        // Пытаемся распарсить JSON
        try {
            return JSON.parse(value);
        } catch (e) {
            // Если не JSON, возвращаем как строку
            return value;
        }
    },
    
    set(target, prop, value) {
        // Игнорируем системные свойства
        if (prop === 'constructor' || prop === '__proto__') {
            return false;
        }
        
        if (value === null || value === undefined) {
            // Удаляем если значение null или undefined
            localStorage.removeItem(prop);
        } else if (typeof value === 'object' || Array.isArray(value)) {
            // Объекты и массивы сериализуем в JSON
            localStorage.setItem(prop, JSON.stringify(value));
        } else {
            // Примитивы конвертируем в строку
            localStorage.setItem(prop, String(value));
        }
        return true; // Важно: всегда возвращать true для успешной записи
    },
    
    deleteProperty(target, prop) {
        localStorage.removeItem(prop);
        return true;
    },
    
    // Для Object.keys(), for...in
    ownKeys() {
        return Object.keys(localStorage);
    },
    
    // Для оператора 'in'
    has(target, prop) {
        return localStorage.getItem(prop) !== null;
    },
    
    // Для Object.getOwnPropertyDescriptor()
    getOwnPropertyDescriptor(target, prop) {
        const value = localStorage.getItem(prop);
        if (value !== null) {
            return {
                value: value,
                writable: true,
                enumerable: true,
                configurable: true
            };
        }
    }
});

export { storage };